import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, useTheme } from '@mui/material';
import { apiActivity } from '../../services/apiActivity';

/**
 * A thin top-of-viewport progress bar that appears whenever the app has any
 * in-flight API request. Driven purely by the apiClient interceptors via
 * apiActivity, so it reflects real network activity across the whole app.
 */
const GlobalActivityBar: React.FC = () => {
  const theme = useTheme();
  const [active, setActive] = useState(false);

  useEffect(() => apiActivity.subscribe((isActive) => setActive(isActive)), []);

  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: theme.zIndex.appBar + 2,
        pointerEvents: 'none',
        opacity: active ? 1 : 0,
        transition: 'opacity .2s ease',
      }}
    >
      {active && <LinearProgress sx={{ height: 3 }} />}
    </Box>
  );
};

export default GlobalActivityBar;
